// extracted by mini-css-extract-plugin
export default {"control":"Product_control__coLya","richText":"Product_richText__r8rd0"};